import { Reducer } from 'redux';

import { EmailsState } from './types';

const defaultState: EmailsState = {
    email: null,
    emailLoading: false,
    msgId: null,
};

const reducer: Reducer<EmailsState> = (state: EmailsState = defaultState, action): EmailsState => {
    switch (action.type) {
        case '@@emails/VIEW_START':
        case '@@emails/VIEW_ERROR':
        case '@@emails/VIEW_SUCCESS':
            return { ...state, email: action.payload.email, emailLoading: action.payload.emailLoading };
        case '@@emails/CLEAR_VIEW_EMAIL': {
            return {
                ...state,
                email: null,
                emailLoading: false,
            };
        }
        case '@@emails/SET_EMAIL_MSGID':
            return { ...state, msgId: action.payload.msgId };
        default:
            return state;
    }
};

export { reducer as emails };

export default reducer;
